// /concepts is an alias of the canonical concept layer at /codex.
// Redirect permanently so there is exactly one indexable concept hub.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/concepts/")({
  beforeLoad: () => {
    throw redirect({ to: "/codex", statusCode: 301 });
  },
});
